module.exports = __webpack_public_path__ + "35e8c606dacf23fc980ea42dc1487bf5.MP3";